import { makeApiClient } from './client';

export const smartProfileApiWithTimeout = makeApiClient(
  `${process.env.NEXT_PUBLIC_AI_PROFILES_API}`,
  {
    timeout: 5000,
  },
);

export const smartProfileApi = makeApiClient(
  `${process.env.NEXT_PUBLIC_AI_PROFILES_API}`,
);
